import React, { useRef } from 'react';
import classnames from 'classnames';

// Hooks
import useElementDimensions from 'Wpds/hooks/useElementDimensions';

// Components
import { WpButton, WpButtonGroup } from '../button';
import WpIcon from '../icon/WpIcon';

import './WpAnnouncementContainer.scss';

type Props = {
  image?: string;
  title?: string;
  text?: string | React.ReactNode;
  onDismiss?: Function;
  button?: React.ReactNode;
  color?: 'gray' | 'purple';
};

const WpAnnouncementContainer = ({ image, title, text, onDismiss, button, color = 'gray' }: Props) => {
  const ref = useRef(null);

  const { width: elementWidth } = useElementDimensions({ elementRef: ref });

  const handleOnDismiss = () => {
    onDismiss && onDismiss();
  };

  const baseClassName = 'WpAnnouncementContainer';
  const classes = classnames(baseClassName, `${baseClassName}--color-${color}`);

  return (
    <div className={classes} ref={ref}>
      {image && (
        <div className={`${baseClassName}__image-wrapper`}>
          <img src={image} className={`${baseClassName}__image-wrapper__image`} />
        </div>
      )}
      <div className={`${baseClassName}__body`}>
        {title && <p className={`${baseClassName}__title`}>{title}</p>}
        {text && <p className={`${baseClassName}__text`}>{text}</p>}
        {button && elementWidth <= 762 && <div className={`${baseClassName}__body__button`}>{button}</div>}
      </div>
      {(onDismiss || (button && elementWidth > 762)) && (
        <div className={`${baseClassName}__buttons`}>
          <WpButtonGroup>
            {button && elementWidth > 762 && <>{button}</>}
            {onDismiss && (
              <WpButton size="sm" variant="tertiary" onClick={handleOnDismiss}>
                <WpIcon name="times" />
              </WpButton>
            )}
          </WpButtonGroup>
        </div>
      )}
    </div>
  );
};

export default WpAnnouncementContainer;
